export const downloadBlob = (blob: Blob, fileName: string) => {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.setAttribute('style', 'display: none');
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
};
